import angular from 'angular';
import ngMessages from 'angular-messages';
import constants from 'app/constants';
import {
  loaderService,
  orgDataService,
  ssDialogService,
  theSafeSharedModelService,
  userService,
  vmDataService,
  vmSharedModelService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import assignVendorManagersDialog from '../dialog.assignVendorManagersDialog';
import editAlertRecipientDialog from '../dialog.editAlertRecipientDialog';
import vendorName from './vendor-name.directive';
import controller from './edit-vendor-dialog.controller';
import template from './edit-vendor-dialog.html';
import validator, { name as validatorName } from './unique-vendor-name.validator.directive';
import vendorCityMessagesTpl from './messages/vendor.city.messages.html';
import vendorNameMessagesTpl from './messages/vendor.name.messages.html';
import vendorPhoneMessagesTpl from './messages/vendor.phone.messages.html';
import vendorStreetMessagesTpl from './messages/vendor.street.messages.html';
import vendorTaxIdMessagesTpl from './messages/vendor.tax-id.messages.html';
import vendorWebsiteMessagesTpl from './messages/vendor.website.messages.html';
import vendorZipMessagesTpl from './messages/vendor.zip.messages.html';
import vendorSuiteMessagesTpl from './messages/vendor.suite.messages.html';


class dialogService {
  getOptions($event, {
    vendor,
    addCallback
  }) {
    return {
      controller,
      controllerAs: 'editVendorDialogVM',
      locals: {
        vendor,
        addCallback,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.editVendorDialog', [
  ngMessages,
  alerts,
  confirmDialog,
  constants,
  loaderService,
  orgDataService,
  ssDialogService,
  theSafeSharedModelService,
  userService,
  vmDataService,
  vmSharedModelService,
  assignVendorManagersDialog,
  editAlertRecipientDialog,
])
  .directive(validatorName, validator)
  .directive('vmVendorName', vendorName)
  .service('editVendorDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('vendor.name.messages.html', vendorNameMessagesTpl);
    $templateCache.put('vendor.phone.messages.html', vendorPhoneMessagesTpl);
    $templateCache.put('vendor.tax-id.messages.html', vendorTaxIdMessagesTpl);
    $templateCache.put('vendor.street.messages.html', vendorStreetMessagesTpl);
    $templateCache.put('vendor.city.messages.html', vendorCityMessagesTpl);
    $templateCache.put('vendor.website.messages.html', vendorWebsiteMessagesTpl);
    $templateCache.put('vendor.zip.messages.html', vendorZipMessagesTpl);
    $templateCache.put('vendor.suite.messages.html', vendorSuiteMessagesTpl);
  })
  .name;
